var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { Group, GroupType, Invitations, PendingContacts } from "@@/Group";
import { action, makeObservable, observable } from "mobx";
import { LetrwingTableState } from '@/app/uistore/LetrwingTable';
import { NewInviteAcceptDecline } from "@/share/NewInvite";
import { ExternalContactEdit, ExternalEditOpt } from "@/share/ExternalContactEdit";
import { LocalWorkingState } from "@/app/UIComponents/LocalWorkingDiloag";
import { UserInformationState } from "@/app/UIComponents/UserInformationDialog";
import { NStore } from "@/background/store/NotifyStore";
import { UserRole } from "@/share/InternalUserStat";
import { AppState } from "@/share/AppState";
import { MasterKeyRequest, MasterKeyRequestType } from "@/share/MasterKeyReq";
export var GroupLoadState;
(function (GroupLoadState) {
    GroupLoadState[GroupLoadState["Unknown"] = 0] = "Unknown";
    GroupLoadState[GroupLoadState["Loading"] = 1] = "Loading";
    GroupLoadState[GroupLoadState["Loaded"] = 2] = "Loaded";
    GroupLoadState[GroupLoadState["Error"] = 3] = "Error";
})(GroupLoadState || (GroupLoadState = {}));
export var ContactPanels;
(function (ContactPanels) {
    ContactPanels[ContactPanels["InternalContact"] = 0] = "InternalContact";
    ContactPanels[ContactPanels["LetrwingContact"] = 1] = "LetrwingContact";
    ContactPanels[ContactPanels["OrgDirectory"] = 2] = "OrgDirectory";
    ContactPanels[ContactPanels["External"] = 3] = "External";
    ContactPanels[ContactPanels["APPUser"] = 4] = "APPUser";
    ContactPanels[ContactPanels["ConnectionRequests"] = 5] = "ConnectionRequests";
    ContactPanels[ContactPanels["WaitingInvitationResponse"] = 6] = "WaitingInvitationResponse";
    ContactPanels[ContactPanels["PendingInvites"] = 7] = "PendingInvites";
    ContactPanels[ContactPanels["NewInvites"] = 8] = "NewInvites";
    ContactPanels[ContactPanels["PersonalGroups"] = 9] = "PersonalGroups";
    ContactPanels[ContactPanels["OrgGroups"] = 10] = "OrgGroups";
    ContactPanels[ContactPanels["Connects"] = 11] = "Connects";
})(ContactPanels || (ContactPanels = {}));
export class GroupStore {
    constructor() {
        this.group = new Map();
        this.loadstatus = GroupLoadState.Unknown;
        this.showExternalInviteDialog = false;
        this.pendingInvites = new Map();
        this.newInvites = new Map();
        this.activetab = 'internal';
        this.selectedExternalContacts = new Set();
        this.appusers = new Map();
        this.rawGroup = new Map();
        this.newinviteTableState = new LetrwingTableState([], (inv) => inv.id);
        this.externalTableState = new LetrwingTableState([], (grp) => grp.id);
        this.personGroupTableState = new LetrwingTableState([], (group) => group.id);
        this.orgGroupTableState = new LetrwingTableState([], (group) => group.id);
        this.externalWorkingDialog = new LocalWorkingState();
        this.selectedContactPanel = ContactPanels.InternalContact;
        this.userInformationState = new UserInformationState();
        this.loadingpendinginvites = false;
        this.loadingnewinvites = false;
        this.showprofile = false;
        this.showmenu = false;
        this.masterkey = "";
        makeObservable(this);
        this.externalTableState.onRowSelecChanged = (sel, row) => this.contactSelectionChanged(sel, row);
        APPEvent.addSubscriberForReset(() => this.reset());
        APPEvent.addSubscriberForAppState((st) => {
            if (st === AppState.LoggedIn) {
                this.loadGroups();
                this.loadmasterkey();
                this.loadOrgAppUsers();
            }
            else {
                this.clearOrgAppUser();
            }
        });
        APPEvent.addSubscriberForGetorgAppUser((us) => {
            for (const u of us) {
                this.setorgAppUser(u);
            }
        });
        APPEvent.addSubscriberForActivateUser((suc) => {
            if (!suc.success) {
                APPEvent.publishApperror("Sorry, failed to activate user. Please contact support");
            }
            this.externalWorkingDialog.setOpen(false);
        });
        APPEvent.addSubscriberForGroups((res) => {
            if (res.error) {
                if (this.loadstatus === GroupLoadState.Loading && (this.activetab === 'internal' || this.activetab === 'external')) {
                    //APPEvent.publishApperror("Sorry, failed to load contacts.");
                }
            }
            else {
                this.addGroups(res.groups);
            }
        });
        APPEvent.addSubscriberForAdminDeleteUser((del) => {
            if (!del.success) {
                APPEvent.publishApperror("Sorry, failed to delete user. Please contact support");
            }
            this.externalWorkingDialog.setOpen(false);
        });
        APPEvent.addSubscriberForAdminEditUserRequestRes((res) => {
            if (res.length > 0 && !res[0].success) {
                APPEvent.publishApperror("Sorry, failed to block the user. Please contact support");
            }
            this.externalWorkingDialog.setOpen(false);
        });
        APPEvent.addSubscriberForAllPendingInvites((inv) => {
            if (inv !== undefined) {
                const ids = new Set();
                inv.map(c => {
                    ids.add(c.id);
                    this.addPendingInvites(c);
                });
                const keys = Array.from(this.pendingInvites.keys());
                for (const key of keys) {
                    if (!ids.has(key)) {
                        this.deletePendInvite(key);
                    }
                }
            }
            this.setLoadingPendingInvite(false);
        });
        APPEvent.addSubscriberForNewInvites((inv) => {
            if (inv !== undefined) {
                const ids = new Set();
                inv.map(c => {
                    ids.add(c.id);
                    this.addNewInvite(c);
                });
                const keys = Array.from(this.newInvites.keys());
                for (const key of keys) {
                    if (!ids.has(key)) {
                        this.deleteInvitations(key);
                    }
                }
            }
            this.setLoadingNewInvites(false);
        });
        APPEvent.addSubscriberForExternalContactResponse((res) => this.editExternalContactResponse(res));
        APPEvent.addSubscriberForMasterKeyResponse((res) => {
            if (res.type === MasterKeyRequestType.GetM) {
                this.setMasterKey("");
            }
        });
        APPEvent.addSubscriberForDeleteAppUser((ud) => {
            if (ud.delids) {
                for (const d of ud.delids) {
                    this.removeAppCon(d);
                }
            }
        });
        APPEvent.addSubscriberForAddAppUser((us) => {
            console.log('us');
            console.log(us);
            if (us.type === 'add') {
                if (us.ok) {
                    // we should add these now!!
                    for (const u of us.us) {
                        this.addAppUser(u);
                    }
                }
            }
        });
    }
    addAppUser(user) {
        this.appusers.set(user.id, user);
    }
    removeAppCon(id) {
        this.appusers.delete(id);
    }
    loadOrgAppUsers() {
        Apphandler.sendMessage("orgappusers", "");
    }
    getOrgAppUsers() {
        return Array.from(this.appusers.values()).sort((v1, v2) => v1.name.toLowerCase().localeCompare(v2.name.toLowerCase()));
    }
    setorgAppUser(u) {
        this.appusers.set(u.id, u);
    }
    clearOrgAppUser() {
        this.appusers.clear();
    }
    setMasterKey(m) {
        this.masterkey = m;
    }
    setShowContactsMenu(show) {
        this.showmenu = show;
    }
    setShowProfile(show) {
        this.showprofile = show;
    }
    editExternalContactResponse(res) {
        res.forEach((r) => {
            if (r.success && r.editopt === ExternalEditOpt.Delete) {
                const ogrp = this.group.get(r.grp.id);
                if (ogrp !== undefined) {
                    this.externalTableState.removeRow(ogrp);
                    this.selectedExternalContacts.delete(r.grp);
                    this.group.delete(r.grp.id);
                    this.rawGroup.delete(r.grp.id);
                }
            }
        });
        this.externalWorkingDialog.setOpen(false);
    }
    contactSelectionChanged(sel, contact) {
        const rawobj = this.rawGroup.get(contact.id);
        if (rawobj === undefined) {
            return;
        }
        if (sel) {
            this.selectedExternalContacts.add(rawobj);
        }
        else {
            this.selectedExternalContacts.delete(rawobj);
        }
    }
    deleteSelectedContacts() {
        if (this.selectedExternalContacts.size > 0) {
            this.deleteExternalContact(Array.from(this.selectedExternalContacts));
        }
    }
    deleteMyTeamMember(id) {
        const req = {
            userid: id,
            newrole: UserRole.Admin,
            name: '',
            disableuser: false
        };
        this.externalWorkingDialog.setMessage("Deleting...");
        this.externalWorkingDialog.setOpen(true);
        Apphandler.sendMessage("deleteuser", req);
    }
    unblockuser(id) {
        this.externalWorkingDialog.setMessage("Unblocking...");
        this.externalWorkingDialog.setOpen(true);
        Apphandler.sendMessage("enableuser", id);
    }
    activateUser(id) {
        this.externalWorkingDialog.setMessage("Activating...");
        this.externalWorkingDialog.setOpen(true);
        Apphandler.sendMessage("activateuser", id);
    }
    blockUser(id) {
        const req = [];
        req.push({
            name: id.name,
            newrole: id.role,
            disableuser: false,
            userid: id.id
        });
        this.externalWorkingDialog.setMessage("Blocking...");
        this.externalWorkingDialog.setOpen(true);
        Apphandler.sendMessage('adminedituser', req);
    }
    deleteExternalContact(contacts) {
        this.externalWorkingDialog.setMessage("Deleting...");
        this.externalWorkingDialog.setOpen(true);
        const req = [];
        contacts.forEach((c) => {
            req.push(new ExternalContactEdit(c, ExternalEditOpt.Delete));
        });
        Apphandler.sendMessage("externalcontactedit", req);
    }
    loadNewInvites() {
        this.setLoadingNewInvites(true);
        Apphandler.sendMessage("getnewinvites", "");
    }
    loadPenidngInvites() {
        this.setLoadingPendingInvite(true);
        Apphandler.sendMessage("getpending", "");
    }
    addNewInvite(inv) {
        if (!this.newInvites.has(inv.id)) {
            this.newInvites.set(inv.id, inv);
            // this.newinviteTableState.addRow(inv);
            if (!this.loadingnewinvites) {
                NStore.sendNotification("New invitiation from " + inv.invitingusername + " (" + inv.invitingcompanyname + ")");
            }
        }
    }
    setLoadingNewInvites(loading) {
        this.loadingnewinvites = loading;
    }
    setLoadingPendingInvite(loading) {
        this.loadingpendinginvites = loading;
    }
    addPendingInvites(pi) {
        this.pendingInvites.set(pi.id, pi);
    }
    deletePendInvite(id) {
        this.pendingInvites.delete(id);
    }
    deleteInvitations(id) {
        this.newInvites.delete(id);
    }
    setShowExtenalInviteDialog(show) {
        this.showExternalInviteDialog = show;
    }
    reset() {
        this.group = new Map();
        this.rawGroup = new Map();
        this.externalTableState.removeAllRows();
        this.newinviteTableState.removeAllRows();
        this.newInvites = new Map();
        this.setLoadStatus(GroupLoadState.Unknown);
    }
    setLoadStatus(status) {
        this.loadstatus = status;
    }
    addGroups(groups) {
        this.setLoadStatus(GroupLoadState.Loaded);
        groups.forEach(grp => this.addGroup(grp));
    }
    addGroup(group) {
        if (!this.group.has(group.id)) {
            if (group.isUserGroup) {
                if (group.type === GroupType.External) {
                    this.externalTableState.addRow(group);
                }
            }
            else if (group.orgGrp) {
                this.orgGroupTableState.addRow(group);
            }
            else {
                this.personGroupTableState.addRow(group);
            }
        }
        this.group.set(group.id, group);
        this.rawGroup.set(group.id, group);
    }
    getInternalContacts() {
        return Array.from(this.group.values()).filter(grp => grp.isUserGroup && grp.type === GroupType.Internal);
    }
    getExternalContacts() {
        return Array.from(this.group.values()).filter(grp => grp.isUserGroup && grp.type === GroupType.External);
    }
    getAllGroups() {
        return Array.from(this.group.values());
    }
    getAllUserGroups() {
        return Array.from(this.group.values()).filter((grp) => grp.isUserGroup);
    }
    getAllOrganisationGroups() {
        return Array.from(this.group.values()).filter((grp) => grp.orgGrp);
    }
    getAllPersonalGroups() {
        return Array.from(this.group.values()).filter((grp) => !grp.isUserGroup && !grp.orgGrp);
    }
    getGroup(id) {
        return this.group.get(id);
    }
    async loadGroups() {
        if (this.loadstatus === GroupLoadState.Loading) {
            return;
        }
        if (this.loadstatus === GroupLoadState.Unknown) {
            this.setLoadStatus(GroupLoadState.Loading);
        }
        Apphandler.sendMessage("groups", "");
    }
    loadmasterkey() {
        const req = new MasterKeyRequest();
        req.type = MasterKeyRequestType.GetM;
        Apphandler.sendMessage('masterkey', req);
    }
    getPendingInvites() {
        return Array.from(this.pendingInvites.values());
    }
    getNewInvitations() {
        return Array.from(this.newInvites.values()).sort((in1, in2) => in1.invitingusername.toLowerCase().localeCompare(in2.invitingusername.toLowerCase()));
    }
    declineInvite(inv) {
        this.removeInvite(inv);
        const ninv = new NewInviteAcceptDecline();
        ninv.id = inv.id;
        ninv.accept = false;
        Apphandler.sendMessage("newinviteresponse", ninv);
    }
    acceptInvite(inv) {
        const ninv = new NewInviteAcceptDecline();
        ninv.id = inv.id;
        ninv.accept = true;
        Apphandler.sendMessage("newinviteresponse", ninv);
        this.removeInvite(inv);
    }
    removeInvite(inv) {
        if (this.newInvites.has(inv.id)) {
            this.newInvites.delete(inv.id);
        }
        this.newinviteTableState.removeRow(inv);
    }
    setSelectedContactPanel(cont) {
        this.selectedContactPanel = cont;
    }
}
__decorate([
    observable,
    __metadata("design:type", Map)
], GroupStore.prototype, "group", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], GroupStore.prototype, "loadstatus", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], GroupStore.prototype, "showExternalInviteDialog", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], GroupStore.prototype, "pendingInvites", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], GroupStore.prototype, "newInvites", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], GroupStore.prototype, "activetab", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], GroupStore.prototype, "selectedExternalContacts", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], GroupStore.prototype, "appusers", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], GroupStore.prototype, "selectedContactPanel", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], GroupStore.prototype, "loadingpendinginvites", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], GroupStore.prototype, "loadingnewinvites", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], GroupStore.prototype, "showprofile", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], GroupStore.prototype, "showmenu", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], GroupStore.prototype, "masterkey", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GroupStore.prototype, "addAppUser", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], GroupStore.prototype, "removeAppCon", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], GroupStore.prototype, "setorgAppUser", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], GroupStore.prototype, "clearOrgAppUser", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], GroupStore.prototype, "setMasterKey", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], GroupStore.prototype, "setShowContactsMenu", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], GroupStore.prototype, "setShowProfile", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Invitations]),
    __metadata("design:returntype", void 0)
], GroupStore.prototype, "addNewInvite", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], GroupStore.prototype, "setLoadingNewInvites", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], GroupStore.prototype, "setLoadingPendingInvite", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [PendingContacts]),
    __metadata("design:returntype", void 0)
], GroupStore.prototype, "addPendingInvites", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], GroupStore.prototype, "deletePendInvite", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], GroupStore.prototype, "deleteInvitations", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], GroupStore.prototype, "setShowExtenalInviteDialog", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], GroupStore.prototype, "reset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], GroupStore.prototype, "setLoadStatus", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], GroupStore.prototype, "addGroups", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Group]),
    __metadata("design:returntype", void 0)
], GroupStore.prototype, "addGroup", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Invitations]),
    __metadata("design:returntype", void 0)
], GroupStore.prototype, "removeInvite", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], GroupStore.prototype, "setSelectedContactPanel", null);
